import React from "react";
import { useMeasure } from "react-use";
import styled, { FlattenSimpleInterpolation } from "styled-components";

/** fits text into the allotted space */
export function ResponsiveTypography({
  text,
  customCss,
  fontSizeMultiplier,
  maxFontSize,
  minFontSize,
}: {
  text: string;
  customCss?: string | FlattenSimpleInterpolation;
  fontSizeMultiplier?: number;
  maxFontSize?: number;
  minFontSize?: number;
}): React.JSX.Element {
  const [ref, dimensions] = useMeasure<HTMLDivElement>();
  let fontSize = (dimensions.width / text.length) * 1.8;
  if (fontSize > dimensions.height) {
    fontSize = dimensions.height;
  }
  return (
    <ResponsiveTypographyStyles
      className="responsiveTypography"
      ref={ref}
      {...{
        $fontSize: `clamp(
          ${minFontSize ?? 0}px,
          ${fontSize * (fontSizeMultiplier ?? 1)}px,
          ${maxFontSize ?? 999}px
        )`,
        $customCss: customCss,
      }}
    >
      {text}
    </ResponsiveTypographyStyles>
  );
}
const ResponsiveTypographyStyles = styled.div<{
  $fontSize: string;
  $customCss?: string | FlattenSimpleInterpolation;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: ${({ $fontSize }) => $fontSize};
  ${({ $customCss }) => $customCss ?? ""}
`;
